import { render, staticRenderFns } from "./PaperStorageTable.vue?vue&type=template&id=392d7f5e&scoped=true"
import script from "./PaperStorageTable.vue?vue&type=script&lang=js"
export * from "./PaperStorageTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392d7f5e",
  null
  
)

export default component.exports